import { render, staticRenderFns } from "./ListQuickReply.vue?vue&type=template&id=16013e49&scoped=true&"
import script from "./ListQuickReply.vue?vue&type=script&lang=js&"
export * from "./ListQuickReply.vue?vue&type=script&lang=js&"
import style0 from "./ListQuickReply.vue?vue&type=style&index=0&id=16013e49&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16013e49",
  null
  
)

export default component.exports